import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useFavicon } from '@vueuse/core';

const useLogoStore = defineStore('projectLogo', () => {
  const faviconUrl = useFavicon();
  const logoHeaderUrl = ref<string>();

  function setFavicon(url?: string): void {
    faviconUrl.value = url;
  }

  function setLogoHeader(url?: string): void {
    logoHeaderUrl.value = url;
  }

  return {
    faviconUrl,
    logoHeaderUrl,
    setFavicon,
    setLogoHeader,
  };
});

export default useLogoStore;
